(function () {
  'use strict';

  // A product may render TWO independent birthstone groups (Live in the Moment:
  // 1-3 baguette stones on the chain, 1-3 pear stones on the charm, each with
  // its own chart, count and cart property). Everything below is per-ROOT — the
  // old single document.querySelector meant a second group silently did nothing.
  var pickers = document.querySelectorAll('[data-cc-birthstone-picker]');
  if (!pickers.length) return;

  for (var pickerIndex = 0; pickerIndex < pickers.length; pickerIndex++) {
    initBirthstonePicker(pickers[pickerIndex]);
  }

  function initBirthstonePicker(picker) {

  // Conditional single-stone mode (e.g. Connected Initials "Add a Birthstone?"):
  // a Yes/No toggle drives the variant's option3 axis via the existing
  // cc:diamond-changed bridge, reveals/hides one stone slot, clears the stone on
  // No, and requires a stone only when Yes. Handled entirely below; the
  // count-mode path (Garden Bloom) is left byte-identical.
  if (picker.hasAttribute('data-cc-conditional')) {
    initConditional(picker);
    return;
  }

  var minStones = parseInt(picker.dataset.minStones, 10) || 1;
  var maxStones = parseInt(picker.dataset.maxStones, 10) || 5;
  var pickerLabel = picker.dataset.label || 'Birthstones';
  // Cart key for THIS group — "Chain Birthstone 1", "Charm Birthstone 1"…
  // Defaults to "Birthstone" so every single-group product is unchanged.
  var stoneProperty = picker.dataset.property || 'Birthstone';
  var countProperty = picker.dataset.countProperty || '';

  // Fixed-count mode (min == max): the snippet omits the count selector — all
  // maxStones boxes are drawn straight away with the grid open, so there's no lone
  // "How many? N" step. Generalizes the old single-slot (max 1) auto-open to any
  // fixed count. Range mode (min < max) waits for a count pick, byte-identical to before.
  var fixedMode = minStones === maxStones;

  var countSelector = picker.querySelector('[data-cc-count-selector]');
  var slotsContainer = picker.querySelector('[data-cc-slots]');
  // One stone panel per chart: group 0 = birthstone_chart, group 1 = birthstone_chart_2
  // (group 1 only exists when the product has a second chart). removeBtns has one
  // button per panel. Single-chart products have exactly one of each — identical to before.
  var panels = Array.prototype.slice.call(picker.querySelectorAll('[data-cc-stone-panel]'));
  var removeBtns = Array.prototype.slice.call(picker.querySelectorAll('[data-cc-remove-btn]'));
  var hiddenInput = picker.querySelector('[data-cc-birthstones-input]');
  var flowersInput = picker.querySelector('[data-cc-birthflowers-input]');
  var paired = picker.hasAttribute('data-paired');

  // count   = chosen N (0 = none picked yet). stones = fixed array of length
  // count, each entry null (empty slot) or { month, abbrev, stone, flower }.
  // activeSlot = the slot the next stone fills / that the panel targets. Always
  // a valid index while count > 0, null only when there are no slots.
  //
  // gridOpen: the panel shows while slots remain empty and auto-CLOSES once every
  // slot holds a stone. Picking auto-advances to the next empty slot (panel
  // stays); when none remain it closes. Tapping any slot reopens the panel with
  // that slot active, so a completed selection can be edited. No outside-click dismiss.
  // Fixed mode seeds all maxStones slots with the first active and the grid open on
  // load; range mode waits for a count pick (count 0, grid closed).
  var count = fixedMode ? maxStones : 0;
  var stones = fixedMode ? new Array(maxStones).fill(null) : [];
  var activeSlot = fixedMode ? 0 : null;
  var gridOpen = fixedMode;

  // First still-empty slot in [0, count), or -1 if every slot is filled.
  function nextEmptySlot() {
    for (var i = 0; i < count; i++) { if (!stones[i]) return i; }
    return -1;
  }

  // --- Order-data contract (Alex's numbered format, 2026-08-17) ---
  // 1. ONE property per filled stone, in slot order, month included:
  //      2+  properties[Birthstone 1] = "Citrine (November)", [Birthstone 2] = ...
  //      1   properties[Birthstone]   = "Citrine (November)"
  //    Paired products write the flowers the same way under "Birth Flower".
  //    This REPLACES the old space-joined properties[Birthstones]; that input
  //    still exists in the markup but is retired (blank + out of the form) via
  //    ccRetireJoinedInput, because Pipeline cached its name at init.
  //    The month is the slot's own data-month, so it always matches the stone.
  // 2. Event "cc:birthstones-changed" keeps count/min/label/items/flowers/
  //    paired; selectedCount is ADDED for the switcher's price preview only.
  // 3. count emitted MUST equal the real filled stones at add-to-cart time:
  //    emit 0 while any slot is empty (so the switcher's Gate 1 keeps ATC
  //    disabled), the full N only when every slot holds a month — at which
  //    point N === filled stones, exactly as the legacy picker behaved.
  // The month -> stone -> flower mapping and all images come from the panel
  // cell's data- attributes / <img> nodes; this JS never invents them.
  // panelForSlot: slot 0 uses the group-0 panel (birthstone_chart); every later slot
  // uses group 1 (birthstone_chart_2). Falls back to group 0 when there's no second
  // panel, so single-chart products read/select/show exactly as before.
  function panelForSlot(i) {
    var group = i === 0 ? '0' : '1';
    for (var p = 0; p < panels.length; p++) {
      if (panels[p].getAttribute('data-cc-panel-group') === group) return panels[p];
    }
    return panels[0];
  }

  function findCell(month, slotIndex) {
    var p = panelForSlot(slotIndex);
    return p ? p.querySelector('[data-cc-stone][data-month="' + month + '"]') : null;
  }

  function emit() {
    var filled = stones.filter(Boolean);
    var allFilled = count > 0 && filled.length === count;

    // Post the chosen count for this group when the product asked for it.
    // Written only once a count exists, so a blank picker posts no key.
    if (countProperty) {
      window.ccWriteNumberedProps(picker, countProperty, count > 0 ? [String(count)] : []);
    }
    window.ccWriteNumberedProps(picker, stoneProperty, filled.map(function (s) {
      return s.stone + ' (' + window.ccMonthName(s.month) + ')';
    }));
    if (paired) {
      window.ccWriteNumberedProps(picker, 'Birth Flower', filled.map(function (s) {
        return s.flower + ' (' + window.ccMonthName(s.month) + ')';
      }));
    }
    window.ccRetireJoinedInput(hiddenInput);
    window.ccRetireJoinedInput(flowersInput);

    document.dispatchEvent(new CustomEvent('cc:birthstones-changed', {
      detail: {
        count: allFilled ? count : 0,
        selectedCount: count,
        items: filled.map(function (s) { return s.stone; }),
        flowers: paired ? filled.map(function (s) { return s.flower; }) : [],
        paired: paired,
        label: pickerLabel,
        min: minStones
      }
    }));
  }

  function renderCountSelector() {
    if (!countSelector) return;
    countSelector.querySelectorAll('[data-cc-count]').forEach(function (btn) {
      var isOn = parseInt(btn.dataset.ccCount, 10) === count;
      btn.classList.toggle('is-selected', isOn);
      btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
    });
  }

  function renderSlots() {
    slotsContainer.innerHTML = '';

    for (var i = 0; i < count; i++) {
      var entry = stones[i];
      var slot = document.createElement('button');
      slot.type = 'button';
      slot.dataset.index = i;

      if (entry) {
        slot.className = 'cc-birthstone-picker__slot cc-birthstone-picker__slot--filled';
        if (activeSlot === i) slot.className += ' is-editing';
        var slotName = paired ? entry.stone + ' with ' + entry.flower : entry.stone;
        slot.setAttribute('aria-label', slotName + '. Tap to change or remove.');

        // Clone the swatch(es) from the panel cell — single source of truth for
        // src/srcset/sizes/alt lives in the snippet markup, not duplicated here.
        // Paired cells carry two images (stone + flower); single cells carry one.
        var cell = findCell(entry.month, i);
        var cellImgs = cell ? cell.querySelectorAll('img') : [];
        cellImgs.forEach(function (cellImg, imgIdx) {
          var slotImg = cellImg.cloneNode(true);
          slotImg.className = 'cc-birthstone-picker__slot-img' +
            (paired && imgIdx === 1 ? ' cc-birthstone-picker__slot-img--flower' : '');
          slotImg.removeAttribute('loading');
          slot.appendChild(slotImg);
        });

        var label = document.createElement('span');
        label.className = 'cc-birthstone-picker__slot-label';
        label.textContent = entry.abbrev;
        slot.appendChild(label);
      } else {
        slot.className = 'cc-birthstone-picker__slot cc-birthstone-picker__slot--active';
        if (activeSlot === i) slot.className += ' is-editing';
        slot.setAttribute('aria-label', 'Empty slot ' + (i + 1) + '. Tap to choose a birth month.');
      }

      (function (idx) {
        slot.addEventListener('click', function (e) { e.stopPropagation(); setActiveSlot(idx); });
      })(i);
      slotsContainer.appendChild(slot);
    }
  }

  function render() {
    renderCountSelector();
    renderSlots();

    // Show ONLY the panel serving the active slot (and only while gridOpen); hide the
    // rest. Single-chart products have one panel, so this is the old `panel.hidden =
    // !gridOpen` behavior.
    var activePanel = activeSlot === null ? null : panelForSlot(activeSlot);
    panels.forEach(function (p) {
      p.hidden = !(gridOpen && p === activePanel);
    });

    // Gold clear/remove only shows when the active slot holds a stone. Same rule as
    // before, applied to each panel's button; only the visible panel's is seen.
    removeBtns.forEach(function (btn) {
      btn.hidden = activeSlot === null || !stones[activeSlot];
    });

    // Highlight the active slot's chosen month within its panel only, clearing any
    // stale highlight in the other panel.
    panels.forEach(function (p) {
      p.querySelectorAll('[data-cc-stone]').forEach(function (cell) {
        var isSelected = p === activePanel
          && activeSlot !== null
          && stones[activeSlot]
          && stones[activeSlot].month === cell.dataset.month;
        cell.classList.toggle('is-selected', isSelected);
      });
    });

    emit();
  }

  function setCount(n) {
    if (n === count) return;
    if (n < count) {
      // Lowering N: drop the last slot(s) and their stones, keep the rest.
      stones = stones.slice(0, n);
    } else {
      while (stones.length < n) stones.push(null);
    }
    count = n;
    // Point at the first fillable slot and open the panel; if the new count is
    // already fully filled (e.g. lowering N), close it. Null/closed at count 0.
    if (count === 0) {
      activeSlot = null;
      gridOpen = false;
    } else {
      var e = nextEmptySlot();
      if (e === -1) { activeSlot = count - 1; gridOpen = false; }
      else { activeSlot = e; gridOpen = true; }
    }
    render();
  }

  // Re-point which slot the panel fills AND (re)open it — used when the shopper
  // taps a slot to edit it, including a filled slot on a completed selection.
  function setActiveSlot(index) {
    activeSlot = index;
    gridOpen = true;
    render();
    panelForSlot(index).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  if (countSelector) {
    countSelector.querySelectorAll('[data-cc-count]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        setCount(parseInt(this.dataset.ccCount, 10));
      });
    });
  }

  // Bind stone-cell clicks on EVERY panel; a click fills the active slot from that
  // cell's data regardless of which chart the cell belongs to.
  panels.forEach(function (p) {
    p.querySelectorAll('[data-cc-stone]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (activeSlot === null) return;
        var wasEditing = !!stones[activeSlot];
        stones[activeSlot] = {
          month: this.dataset.month,
          abbrev: this.dataset.abbrev,
          stone: this.dataset.stone,
          flower: this.dataset.flower || ''
        };
        // Filling forward vs editing. Advancing is only ever right when this
        // pick FILLED an empty slot: then move to the next empty one and keep
        // the panel open so a run of picks needs no taps in between. If the
        // shopper deliberately reopened an already-filled slot to change it,
        // jumping them somewhere else afterwards is worse than doing nothing -
        // so close the panel and leave them where they were. Either way the
        // panel closes once nothing is left empty.
        if (wasEditing) {
          gridOpen = false;
        } else {
          var e = nextEmptySlot();
          if (e !== -1) { activeSlot = e; }
          else { gridOpen = false; }
        }
        render();
      });
    });
  });

  removeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      // Clears the active slot back to empty (does not remove it — count is fixed),
      // keeps it active and reopens the panel for a re-pick.
      if (activeSlot !== null && stones[activeSlot]) {
        stones[activeSlot] = null;
        gridOpen = true;
        render();
      }
    });
  });

  render();

  // ── Conditional single-stone mode ──────────────────────────────────────────
  function initConditional(root) {
    var slotsContainer = root.querySelector('[data-cc-slots]');
    var panel = root.querySelector('[data-cc-stone-panel]');
    var removeBtn = root.querySelector('[data-cc-remove-btn]');
    var hiddenInput = root.querySelector('[data-cc-birthstones-input]');
    var flowersInput = root.querySelector('[data-cc-birthflowers-input]');
    var reveal = root.querySelector('[data-cc-reveal]');
    var toggleBtns = root.querySelectorAll('[data-cc-bs-toggle]');
    var paired = root.hasAttribute('data-paired');
    var pickerLabel = root.dataset.label || 'Birthstone';

    var enabled = root.dataset.toggleDefault === 'true'; // Yes/No
    var stone = null;                                     // { month, abbrev, stone, flower } or null
    // gridOpen: on Yes the panel shows until a stone is picked, then auto-CLOSES;
    // tapping the slot reopens it to edit. On No the panel is hidden (no slot).
    // No outside-click dismiss. Starts open when the default is Yes (no stone yet).
    var gridOpen = enabled;

    function findCell(month) {
      return panel ? panel.querySelector('[data-cc-stone][data-month="' + month + '"]') : null;
    }

    function emit() {
      // The property is present ONLY when Yes AND a stone is chosen — on No the
      // key is absent (not empty), which clears any orphan birthstone from the
      // order. Contract-critical. Single stone, so it is never numbered.
      var present = enabled && !!stone;
      window.ccWriteNumberedProps(root, (root.dataset.property || 'Birthstone'), present
        ? [stone.stone + ' (' + window.ccMonthName(stone.month) + ')'] : []);
      if (paired) {
        window.ccWriteNumberedProps(root, 'Birth Flower', present
          ? [stone.flower + ' (' + window.ccMonthName(stone.month) + ')'] : []);
      }
      window.ccRetireJoinedInput(hiddenInput);
      window.ccRetireJoinedInput(flowersInput);

      // Variant option3 axis (Add a Birthstone Yes/No) via the existing bridge —
      // the switcher's generic 3rd-axis ("diamond") needs no changes.
      document.dispatchEvent(new CustomEvent('cc:diamond-changed', {
        detail: { value: enabled ? 'Yes' : 'No' }
      }));

      // Required-when-Yes gate via the property-gate registry: min 1 when Yes,
      // min 0 when No (so No never blocks ATC). Also corrects the switcher's
      // init pre-seed, which can't express min 0 through its `|| 1` default.
      document.dispatchEvent(new CustomEvent('cc:birthstones-changed', {
        detail: {
          count: present ? 1 : 0,
          selectedCount: enabled ? 1 : 0,
          items: present ? [stone.stone] : [],
          flowers: (paired && present) ? [stone.flower] : [],
          paired: paired,
          label: pickerLabel,
          min: enabled ? 1 : 0
        }
      }));
    }

    function renderSlot() {
      if (!slotsContainer) return;
      slotsContainer.innerHTML = '';
      var slot = document.createElement('button');
      slot.type = 'button';

      if (stone) {
        slot.className = 'cc-birthstone-picker__slot cc-birthstone-picker__slot--filled';
        if (enabled && gridOpen) slot.className += ' is-editing';
        var slotName = paired ? stone.stone + ' with ' + stone.flower : stone.stone;
        slot.setAttribute('aria-label', slotName + '. Tap to change or remove.');

        var cell = findCell(stone.month);
        var cellImgs = cell ? cell.querySelectorAll('img') : [];
        cellImgs.forEach(function (cellImg, imgIdx) {
          var img = cellImg.cloneNode(true);
          img.className = 'cc-birthstone-picker__slot-img' +
            (paired && imgIdx === 1 ? ' cc-birthstone-picker__slot-img--flower' : '');
          img.removeAttribute('loading');
          slot.appendChild(img);
        });

        var label = document.createElement('span');
        label.className = 'cc-birthstone-picker__slot-label';
        label.textContent = stone.abbrev;
        slot.appendChild(label);
      } else {
        slot.className = 'cc-birthstone-picker__slot cc-birthstone-picker__slot--active';
        if (enabled && gridOpen) slot.className += ' is-editing';
        slot.setAttribute('aria-label', 'Choose a birth month.');
      }

      slot.addEventListener('click', function (e) { e.stopPropagation(); openPanel(); });
      slotsContainer.appendChild(slot);
    }

    function render() {
      var current = enabled ? 'Yes' : 'No';
      toggleBtns.forEach(function (btn) {
        var sel = btn.dataset.ccBsToggle === current;
        btn.classList.toggle('is-selected', sel);
        btn.setAttribute('aria-checked', sel ? 'true' : 'false');
      });

      if (reveal) reveal.hidden = !enabled;
      renderSlot();

      if (panel) {
        panel.hidden = !(enabled && gridOpen);
        panel.querySelectorAll('[data-cc-stone]').forEach(function (cell) {
          cell.classList.toggle('is-selected', !!stone && stone.month === cell.dataset.month);
        });
      }
      if (removeBtn) removeBtn.hidden = !(enabled && gridOpen && stone);

      emit();
    }

    // Slot tap when Yes: (re)open the panel so a chosen stone can be edited.
    function openPanel() {
      if (!enabled || !panel) return;
      gridOpen = true;
      render();
      panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var next = this.dataset.ccBsToggle === 'Yes';
        if (next === enabled) return;
        enabled = next;
        if (!enabled) {        // No clears the stone + hides the panel
          stone = null;
          gridOpen = false;
        } else {               // Yes opens the panel unless a stone is already set
          gridOpen = !stone;
        }
        render();
      });
    });

    if (panel) {
      panel.querySelectorAll('[data-cc-stone]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!enabled) return;
          stone = {
            month: this.dataset.month,
            abbrev: this.dataset.abbrev,
            stone: this.dataset.stone,
            flower: this.dataset.flower || ''
          };
          // Complete (single stone) — close the panel. Tapping the slot reopens it.
          gridOpen = false;
          render();
        });
      });
    }

    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        // Clears the stone but stays on Yes (slot returns to empty, panel reopens,
        // ATC re-gates).
        if (stone) {
          stone = null;
          gridOpen = true;
          render();
        }
      });
    }

    render();
  }
  }
})();
